import React from 'react';
import '../styles/SimpleLoader.css';

const SimpleLoader = ({ showText = true, size = 'medium' }) => {
  return (
    <div className={`simple-loader ${size}`}>
      <div className="loader-container">
        <div className="dots-container">
          <div className="dot dot-1"></div>
          <div className="dot dot-2"></div>
          <div className="dot dot-3"></div>
        </div>
        {showText && (
          <div className="loading-text">جاري التحميل...</div>
        )}
      </div>
    </div>
  );
};

export default SimpleLoader; 